import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useKeycloak } from '@react-keycloak/web';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useToast } from '../hooks/useToast';
import { useTranslation } from 'react-i18next';

import useAuth from '../hooks/useAuth.hook';
import { useAppDispatch } from '../hooks/useAppDispatcher.hook';
import { getUserSelfThunk } from '../redux/User/UserThunk';
import axiosService from '../services/axios.service';
import {
  getIsBaseRouteVisited,
  setIsBaseRouteVisited,
  setIsLogged,
  getServerError,
  setServerError,
} from '../redux/App/App.slice';

import RootContainer from './RootContainer';
import InitScreen from './InitScreen';
import { isBaseRoute } from '../utils/routes';

const StyledApp = styled.div`
  background: ${({ theme }) => theme.colors.BG};
  min-height: 100vh;
  overflow-x: hidden;

  a {
    transition: color 0.2s;

    :hover {
      color: ${({ theme }) => theme.colors.BLUE.B400};
    }
  }
`;

const App = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const { successToast, errorToast } = useToast();
  const { t } = useTranslation();
  const isBaseRouteVisited = useSelector(getIsBaseRouteVisited);
  const serverError = useSelector(getServerError);
  const { user, hasAccessError } = useAuth();
  const { keycloak } = useKeycloak();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // @ts-ignore
    axiosService.dispatch = dispatch;
  }, []);

  useEffect(() => {
    if (serverError) {
      errorToast(
        `${t('Error')} ${serverError?.response.status}: ${serverError.code}`,
      );
      setTimeout(() => {
        dispatch(setServerError(undefined));
      }, 3000);
    }
  }, [serverError]);

  useEffect(() => {
    dispatch(setIsLogged(!!keycloak.authenticated));
  }, [keycloak]);

  useEffect(() => {
    setIsLoaded((!!user && !!keycloak.authenticated) || hasAccessError);
  }, [keycloak, user, hasAccessError]);

  useEffect(() => {
    keycloak.authenticated && dispatch(getUserSelfThunk());
  }, [keycloak.authenticated]);

  useEffect(() => {
    if (!isBaseRouteVisited && isBaseRoute(location.pathname)) {
      dispatch(setIsBaseRouteVisited(true));
    }
  }, [location.pathname, isBaseRouteVisited, dispatch]);

  return (
    <StyledApp>
      {isLoaded ? (
        <RootContainer hasAccessError={hasAccessError} />
      ) : (
        <InitScreen />
      )}
    </StyledApp>
  );
};
export default App;
